import GRPCLuna from "./GRPCLuna"
import type {Resolve, Reject} from "../utility/InterfacePromise"

import {
    E24UserSupportRequest,
    EudUserSupport
} from "@ev24/proto-eud-luna-web-api/elwa_v1_pb"
import {
    EudUserMessagingServiceClient
} from "@ev24/proto-eud-luna-web-api/elwa_v1_grpc_web_pb"

export interface SupportFields {
  token?: string; // Auth token
  related_to: string; // URL
  fullname: string; // users name
  email: string; // users email
  problem: string; // users comments
}

export default class LunaSupport extends GRPCLuna {

    public async send(fields: SupportFields, recaptchaToken: string | undefined = '') {
        const UUID = this.getUuid();
        const payload: EudUserSupport = new EudUserSupport();
        payload.setProblem(fields.problem)
        if(fields.email) {
            payload.setEmail(fields.email)
        }
        if(fields.fullname) {
            payload.setFullname(fields.fullname)
        }
        payload.setRelatedTo(fields.related_to)
        payload.getMetaMap().set('time', new Date().toISOString())

        const request: E24UserSupportRequest = new E24UserSupportRequest()
        request.setRecaptchaToken(recaptchaToken || '')
        request.setPayload(payload)
        request.setToken(fields.token || '')
        request.setRequestId(UUID)

        return new Promise((resolve: Resolve, reject: Reject): void => {
            const serviceClient = new EudUserMessagingServiceClient(this._path, this._options);
            serviceClient.sendSupport(
                request,
                this._headers,
                (err, response) => {
                    this.genericHandler("Thank you for contacting Evolve24.", response, err, resolve, reject);
                }
            )
        })
    }
}